module.exports = __webpack_public_path__ + "images/stickers/pete-sketch@2x.90cba9d180d3c72875cd.png";